"use client";
import { Button } from "@heroui/react";
import { clx } from "@medusajs/ui";
import Spinner from "@modules/common/icons/spinner";
import { ReactNode } from "react";

interface CustomButtonProps {
  variant?: "primary" | "secondary";
  children: ReactNode;
  className?: string;
  isLoading?: boolean;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  "data-testid"?: string;
  onClick?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
}

const ButtonCustom = ({
  variant = "primary",
  children,
  className,
  type = "button",
  isLoading = false,
  onClick,
  disabled,
  "data-testid": dataTestId,
  ...props
}: CustomButtonProps) => {
  const baseStyles =
    "min-h-10 cursor-pointer border text-center w-full transition-all disabled:cursor-not-allowed disabled:bg-opacity-50 disabled:border-0 disabled:bg-[#D4D4D8] disabled:text-[#4d4d4d]";

  const variants = {
    primary:
      "bg-primary text-white hover:bg-primary-hover hover:border-primary-hover active:bg-primary-active border-primary",
    secondary:
      "border-primary text-primary bg-white hover:bg-[#E5F1FF] hover:border-primary-active active:bg-[#E5F1FF]",
  };

  return (
    <Button
      {...props}
      type={type}
      disabled={isLoading || disabled}
      onClick={(event) => onClick?.(event)}
      data-testid={dataTestId}
      className={clx(baseStyles, variants[variant], className)}
    >
      {isLoading ? <Spinner className="animate-spin" /> : children}
    </Button>
  );
};

export default ButtonCustom;
